/**
 * Cache Manager Service
 * Provides utilities for clearing various types of app caches
 */

/**
 * Clear all Service Worker caches
 * This removes cached assets, API responses, and offline data
 */
async function clearServiceWorkerCaches(): Promise<void> {
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    } catch (error) {
      console.error('Failed to clear Service Worker caches:', error);
      throw error;
    }
  }
}

/**
 * Clear browser storage (localStorage and sessionStorage)
 */
function clearBrowserStorage(): void {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error('Failed to clear browser storage:', error);
    throw error;
  }
}

/**
 * Clear all app caches
 * This includes:
 * - Service Worker caches (offline assets, API responses)
 * - localStorage (persisted app state)
 * - sessionStorage (session-specific data)
 *
 * Note: React Query cache should be cleared separately using queryClient.clear()
 * as it requires access to the QueryClient instance.
 */
export async function clearAllCaches(): Promise<void> {
  await Promise.all([
    clearServiceWorkerCaches(),
    Promise.resolve(clearBrowserStorage()),
  ]);
}


